<template>
    <CutRequestHistory></CutRequestHistory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CutRequestHistory = defineAsyncComponent(() =>
    import("../../components/CNC/CutRequestHistory.vue")
);

export default {
    name: "Cut_Request_History", //The name you are in should not equal the name of the component you are importing.
    components: { CutRequestHistory, AuthLayout },
};
</script>

<style scoped></style>
